import { Component, OnInit } from "@angular/core";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";

@Component({
	selector: "app-block-list-setup",
	templateUrl: "./block-list-setup.component.html",
	styleUrls: ["./block-list-setup.component.css"],
})
export class BlockListSetupComponent implements OnInit {
	constructor(private selectService: SchoolselectorService) {}
	ngOnInit(): void {
		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			this.onSchoolChange(school);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	//////////////////////////////////////////////////////////////
	// Data
	//////////////////////////////////////////////////////////////

	subscription: any;

	SelectedSchool: any;
	SchoolSelectShowAllID: any = 0;
	SchoolSelectShowAllText: any = "All Schools";

	AllDates: boolean = true;
	StartDate: Date = new Date();
	EndDate: Date = new Date();

	SelectedStationBlockAlert: any;

	//////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////
	// Events
	//////////////////////////////////////////////////////////////

	onSchoolChange(val) {
		this.SelectedSchool = val;
	}

	onBlockListSelected(val) {
		this.SelectedStationBlockAlert = val;
	}

	//////////////////////////////////////////////////////////////
}
